/* BELORA — SKIMS PURE · email forms (footer signup, announcement signup panel, PDP waitlist)

   Invalid address: the browser's own bubble — in the browser's language and style — is replaced by the
   form's inline message, the same line the server uses for its errors, in Turkish from the theme editor:
   under the field, announced (role="alert"), with aria-invalid and aria-describedby on the field. Native
   constraint validation still decides validity and still stops the submit; only the paint changes. The
   message clears as the customer types.

   Back from a post: both newsletter forms are Shopify customer forms, so the server paints the result into
   both. The address fragment names the one that was sent (#contact_form = footer, #sk-signup-form = panel),
   and the other form's "thank you" line is hidden so the page does not say it twice. */
(function () {
  'use strict';

  var FORMS = [
    { form: '.sk-footer__form', msg: '[data-sk-invalid]' },
    { form: '.sk-signup__form', msg: '[data-sk-invalid]' },
    { form: '#sk-waitlist form', msg: '[data-sk-wl-invalid]' },
  ];
  var count = 0;

  function wire(form, msgSelector) {
    var input = form.querySelector('input[type="email"]');
    var msg = form.querySelector(msgSelector);
    if (!input || !msg || input.hasAttribute('data-sk-validate')) return;
    input.setAttribute('data-sk-validate', '');
    if (!msg.id) msg.id = 'sk-invalid-' + (++count);

    input.addEventListener('invalid', function (e) {
      e.preventDefault();
      if (msg.hidden) msg.hidden = false;
      input.setAttribute('aria-invalid', 'true');
      var ids = (input.getAttribute('aria-describedby') || '').split(' ').filter(Boolean);
      if (ids.indexOf(msg.id) === -1) {
        ids.push(msg.id);
        input.setAttribute('aria-describedby', ids.join(' '));
      }
      if (document.activeElement !== input) input.focus();
    });

    input.addEventListener('input', function () {
      if (msg.hidden) return;
      msg.hidden = true;
      input.removeAttribute('aria-invalid');
    });
  }

  function init() {
    FORMS.forEach(function (f) {
      Array.prototype.forEach.call(document.querySelectorAll(f.form), function (form) { wire(form, f.msg); });
    });

    if (/[?&]customer_posted=true/.test(location.search)) {
      var sent = null;
      if (location.hash === '#contact_form') sent = '.sk-footer__form';
      else if (location.hash === '#sk-signup-form') sent = '.sk-signup__form';
      if (sent) {
        Array.prototype.forEach.call(document.querySelectorAll('.sk-footer__form, .sk-signup__form'), function (form) {
          if (form.matches(sent)) return;
          Array.prototype.forEach.call(form.querySelectorAll('.sk-footer__ok'), function (m) { m.hidden = true; });
        });
      }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
